function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.293 0.292995L3.99998 6.586L1.70698 4.293C1.51838 4.11084 1.26578 4.01004 1.00358 4.01232C0.741382 4.0146 0.490569 4.11977 0.305161 4.30518C0.119753 4.49058 0.0145843 4.7414 0.0123059 5.00359C0.0100274 5.26579 0.110822 5.51839 0.29298 5.707L3.29298 8.707C3.48051 8.89447 3.73482 8.99978 3.99998 8.99978C4.26514 8.99978 4.51945 8.89447 4.70698 8.707L11.707 1.707C11.8891 1.51839 11.9899 1.26579 11.9877 1.00359C11.9854 0.741397 11.8802 0.490585 11.6948 0.305176C11.5094 0.119768 11.2586 0.0145995 10.9964 0.0123211C10.7342 0.0100427 10.4816 0.110837 10.293 0.292995Z",
  fill: "#718096"
});

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.eaf579ab.svg";
export { ForwardRef as ReactComponent };